import { getCommissionLeadsEndpoint } from "../config/api";
import type {
  CommissionBudgetRange,
  CommissionProjectType,
  CommissionTimeline,
} from "../data/commissionOptions";

export type SubmitCommissionLeadInput = {
  senderName: string;
  senderEmail: string;
  senderPhone?: string;
  projectType: CommissionProjectType;
  budgetRange?: CommissionBudgetRange;
  timeline?: CommissionTimeline;
  message: string;
  locale?: string;
  sourceUrl?: string;
  referrerPath?: string;
  website?: string;
};

export type SubmitCommissionLeadResult =
  | { ok: true; id: string }
  | { ok: false; error: string };

export async function submitCommissionLead(
  input: SubmitCommissionLeadInput,
): Promise<SubmitCommissionLeadResult> {
  try {
    const res = await fetch(getCommissionLeadsEndpoint(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      return {
        ok: false,
        error:
          typeof data?.error === "string"
            ? data.error
            : "Something went wrong. Please try again or email directly.",
      };
    }

    return { ok: true, id: String(data.id ?? "") };
  } catch {
    return {
      ok: false,
      error: "Network error. Please check your connection or email directly.",
    };
  }
}
